import { render, staticRenderFns } from "./OnvifDiscoveryVersion.vue?vue&type=template&id=3b8cb7e8"
import script from "./OnvifDiscoveryVersion.vue?vue&type=script&lang=js"
export * from "./OnvifDiscoveryVersion.vue?vue&type=script&lang=js"
import style0 from "./OnvifDiscoveryVersion.vue?vue&type=style&index=0&id=3b8cb7e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports